module.exports = __webpack_public_path__ + "img/home-11.6878eb32.webp";